import { BannerEditModel } from "./../../../node_modules/@playcharge/common/models/backend/banners/backoffice/banner-edit-model";
import { HttpClient } from "@angular/common/http";
import { inject, Injectable, model } from "@angular/core";
import { Observable } from "rxjs";
import { ApiRoutes } from "../models/constants/api-routes";
import { ApiUtils } from "../utils/api-utils";
import { BannerBackOfficeViewModel } from "@playcharge/common/models/backend/banners/backoffice/banner-backoffice-view-model";

@Injectable({
    providedIn: "root",
})
export class ApiBannersService {
    private _httpClient = inject(HttpClient);

    public getBanners(): Observable<BannerBackOfficeViewModel[]> {
        return this._httpClient.get<BannerBackOfficeViewModel[]>(
            ApiUtils.buildUrl(ApiRoutes.banners.root),
        );
    }

    public createBanner(model: BannerEditModel): Observable<BannerBackOfficeViewModel> {
        return this._httpClient.post<BannerBackOfficeViewModel>(
            ApiUtils.buildUrl(ApiRoutes.banners.root),
            model,
        );
    }

    public updateBanner(model: BannerEditModel): Observable<BannerBackOfficeViewModel> {
        return this._httpClient.put<BannerBackOfficeViewModel>(
            ApiUtils.buildUrl(ApiRoutes.banners.root),
            model,
        );
    }
}
